import {BaseContainerModel} from '../base-container.model';
import {bl_webhook_subscription_hdr_RowClass} from '../../dbschema/bl_webhook_subscription_hdr.model';

export class WebhookSubscriptionHdrContainerModel extends BaseContainerModel {
  bl_webhook_subscription_hdr: bl_webhook_subscription_hdr_RowClass = new bl_webhook_subscription_hdr_RowClass();
}
